import ApiUrl from "../ApiUrl";

export default async function FetchData(url, options = {}) {
	if(!url.includes("logout"))
		await RefreshToken();

	return await Fetch(url, options);
}

function Fetch(url, options) {
	if(options.headers === undefined)
		options.headers = {};

	options.headers.Authorization = "Bearer " + localStorage.getItem("token");
	return fetch(ApiUrl + url, options)
		.then(response => response.json())
		.then(response => {
			if(response.code !== 200 && response.access_token === undefined)
				response.isError = true;

			if(response.code === 401) {
				if(url === 'user/a_me' || url === 'userapi/user/token' || url.startsWith('userapi/user/refresh_token'))
					return response;

				localStorage.removeItem("token");
				localStorage.removeItem("refresh");
				localStorage.removeItem("time");
				localStorage.setItem("isAdmin", false);
				response.isError = true;
				// response.message = 'Sessie is verlopen';
				response.message = '';
			}

			return response;
		})
		.catch(error => {
			console.log(error);
			error.isError = true;
			return error;
		})
}

async function RefreshToken() {
	const time = localStorage.getItem("time");
	if(time === null)
		return;

	const refresh = localStorage.getItem("refresh");
	if(refresh === null)
		return;

	if(Date.now() - time >= (5 * 60 * 1000)) {
		const header = {
			method: "POST"
		};
		const result = await Fetch(`userapi/user/refresh_token?refresh_token=${localStorage.getItem("refresh")}`, header);
		if(!result.isError) {
			localStorage.setItem("token", result.access_token);
			localStorage.setItem("time", Date.now());
		}
		return !result.isError;
	}
	return true;
}